module.exports = __webpack_public_path__ + "static/media/rhinoceros.6c8ed546.svg";